import React, { Component } from 'react'
// import ReactHtmlParser from 'react-html-parser'
// import reactStringReplace from "react-string-replace-recursively"
// import { renderToString } from 'react-dom/server'
// import Settings from '../settings'

// This component has:
// 1. button with url
// 2. text

class SectionButton extends Component {

   componentDidMount() {

   }

   render() {
      const {
         title = 'Button text',
         url = '/test',
      } = this.props.data

      return (
         <div className="SectionButton">

           <div className="Xfooter-share page-width">
              <a href={url}><div className="button">{title}</div></a>
           </div>

         </div>
      )
   }
}

export default SectionButton



// WEBPACK FOOTER //
// ./src/components/SectionButton.js